module.exports = __webpack_public_path__ + "static/media/realtors-icon-2.fe1de790.svg";